<template>
  <div role="group" class="mb-3">
    <b-form-group :label="question">
      <b-row>
        <b-col cols="10">
          <b-form-input v-model="answerDisplay" readonly></b-form-input>
        </b-col>
        <b-col cols="2">
          <b-button pill block variant="primary" @click="editMode = !editMode"
            >Edit Mode</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="editMode" class="mt-3">
        <b-col>
          <label for="bmi-feet">Feet</label>
          <b-form-input id="bmi-feet" v-model="feet"></b-form-input>
        </b-col>
        <b-col>
          <label for="bmi-inch">Inch</label>
          <b-form-input id="bmi-inch" v-model="inch"></b-form-input>
        </b-col>
      </b-row>
      <b-row v-if="editMode" class="mt-3">
        <b-col>
          <label for="bmi-weight">Weight</label>
          <b-form-input id="bmi-inch" v-model="weight"></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "AccountBMI",
  props: {
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    question: {
      type: String,
      default: "",
    },
    preAnswer: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editMode: false,
      feet: null,
      inch: null,
      weight: null,
    };
  },
  computed: {
    answerDisplay() {
      if (this.feet && this.inch && this.weight) {
        let heightIn = this.feet * 12 + this.inch;
        return this.roundOff((this.weight / heightIn / heightIn) * 703 * 100);
      } else {
        return this.preAnswer;
      }
    },
  },
  watch: {
    editMode() {
      if (!this.editMode) {
        this.feet = this.body.answervalue.height.feet;
        this.inch = this.body.answervalue.height.inch;
        this.weight = this.body.answervalue.weight;
      }
    },
  },
  mounted() {
    if (this.body.answervalue) this.feet = this.body.answervalue.height.feet;
    if (this.body.answervalue) this.inch = this.body.answervalue.height.inch;
    if (this.body.answervalue) this.weight = this.body.answervalue.weight;
  },
  methods: {
    roundOff(num) {
      const x = Math.pow(10, 2);
      return Math.round(num * x) / x;
    },
  },
};
</script>

<style></style>
